/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import Button from '@atlaskit/button/custom-theme-button';
import { gridSize } from '@atlaskit/theme';

export const WebItemButton = styled(Button)({
  marginRight: `${gridSize()}px`,
  '&:last-child': {
    marginRight: 0,
  },
});
